import React, { Component } from 'react';
import { BUTTONS, trackButtonClick } from '../../analytics/buttonEventAnalytics';
import { trackTagPickerOpenedOnTestTag, TICKET_ACTION_SOURCES } from '../../analytics/ticketEventAnalytics';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import MessagesComponent from 'components/Messages/Messages';
import TicketButton from '../Buttons/TicketButton/TicketButton';
import { BUTTON_IDS } from '../../reducers/ui/buttons';
import InboxButtonContainer from '../../containers/tools/InboxButtonContainer';
import InboxTabPickerContainer from '../../containers/inboxPanel/InboxTabPickerContainer';
import {
  NoButtonPlaceholder,
  EscalatedActionButtonHolder,
  InboxButtonWrapper,
  ActionsButtonsWrapper,
} from '../common/buttonsComponents';
import SelectedMessage from '../Messages/SelectedMessage/SelectedMessage';
import { getAccountBrandConfigValue } from '../../util';
import { showExpertReviewNotificationPopup } from '../popups/ExpertReviewNotificationPopup';
import { NOMINATED } from 'constants/tabNames';
import {
  ValidationContainer,
  ValidationText,
  ValidationIcon,
  EscalatedBox,
  MessagesWrapper,
  ActionsButtons,
} from './EscalatedTicketComponent.styles';
import { SHOW_EMAIL_TO_EXPERTS, IS_SHOW_EMAIL_TO_EXPERTS } from 'constants/extraBusinessInfo';

class EscalatedTicketComponent extends Component {
  UNSAFE_componentWillMount() {
    this.props.clearHistoricalTicket();
    this.props.setChatMacroRecommendationsEnabled(true);
  }

  handleEscalateClick = () => {
    const { ticket } = this.props.selectedTicket || {};
    this.props.handleEscalationPopup(ticket);
  };

  onClickTake(buttonId) {
    const {
      onTakeClick,
      simplrTaggingRequired,
      selectedTicket: { ticket, isAdmin },
      currentUser,
    } = this.props;
    if (simplrTaggingRequired) {
      trackTagPickerOpenedOnTestTag(TICKET_ACTION_SOURCES.NOMINATED_TAB);
      this.props.setTaggingActive(true);
      this.props.setShowTools(true);
    } else {
      onTakeClick(ticket.ticketId, ticket.simplrAccountPtrId, isAdmin, buttonId);

      if (!currentUser.expertReviewPopupAcknowledged && ticket.escalatedForReview) {
        showExpertReviewNotificationPopup(currentUser.id);
      }
    }
  }

  render() {
    const {
      selectedTicket: { ticket, selectedInboxTab, isAdmin },
      onRejectClick,
      btnActivity,
      onHideClick,
      setBtnActivity,
      showTools,
      setShowTools,
      businessDetailsForTicket,
      isSelectedHistoricalTicket,
      isTestStoreTicket,
      simplrTaggingActive,
      selectedConversation,
      reviewTicketSelected,
      isExpertDashboardOpened,
      validationTicketSelected,
    } = this.props;

    // if no ticket is selected, render nothing
    if (!ticket || !ticket.simplrAccountPtrId) {
      return null;
    }

    const showOrHide = selectedInboxTab === NOMINATED || reviewTicketSelected || validationTicketSelected ? '' : 'hide';

    let showRejectBtn = selectedInboxTab === NOMINATED && (isAdmin || (!isAdmin && ticket.isTestTicket)) ? 'hide' : '';

    const { escalateTakeBtn, escalateRejectBtn } = BUTTON_IDS;

    const showEmailToExperts = getAccountBrandConfigValue(
      businessDetailsForTicket,
      SHOW_EMAIL_TO_EXPERTS,
      ticket.brand,
      IS_SHOW_EMAIL_TO_EXPERTS
    );

    return (
      <EscalatedBox className={'full-height ' + showOrHide}>
        {!isExpertDashboardOpened ? (
          <EscalatedActionButtonHolder>
            {showTools && (
              <InboxButtonWrapper removePadding={!isAdmin}>
                <InboxButtonContainer />
                {!isAdmin && <InboxTabPickerContainer />}
              </InboxButtonWrapper>
            )}

            {validationTicketSelected && (
              <ValidationContainer>
                <ValidationText>Validation</ValidationText>
                <ValidationIcon alt="validation check icon" src="/images/conversationIcons/validation-check-icon.svg" />
              </ValidationContainer>
            )}

            {!isSelectedHistoricalTicket && (
              <ActionsButtonsWrapper>
                {reviewTicketSelected && !showTools && (
                  <TicketButton label="ACTIONS" onClick={() => setShowTools(!showTools)} />
                )}

                {!reviewTicketSelected && !validationTicketSelected && (
                  <ActionsButtons>
                    {!showTools && (
                      <TicketButton
                        label="ACTIONS"
                        active={!simplrTaggingActive}
                        disabled={simplrTaggingActive}
                        onClick={() => {
                          this.props.setTaggingActive(false);
                          setShowTools(!showTools);
                          trackButtonClick(BUTTONS.ACTIONS);
                        }}
                      />
                    )}
                    {this.props.showButtons ? (
                      <TicketButton
                        label="REJECT"
                        buttonId={escalateRejectBtn}
                        active={btnActivity.escalateRejectBtn && !simplrTaggingActive}
                        className={showRejectBtn}
                        disabled={simplrTaggingActive}
                        clickAction={(buttonId) => {
                          if (isTestStoreTicket) {
                            onHideClick(ticket.ticketId);

                            return;
                          }
                          SessionAnalyticsService.event('Expert Rejected Ticket', {
                            ticket: ticket.ticketId,
                          });
                          onRejectClick(ticket.ticketId, buttonId);
                        }}
                        setBtnActivity={simplrTaggingActive ? null : setBtnActivity}
                      />
                    ) : (
                      <TicketButton
                        label="REJECT"
                        buttonId={escalateRejectBtn}
                        active={btnActivity.escalateRejectBtn && !simplrTaggingActive}
                        className={showRejectBtn}
                        disabled={simplrTaggingActive}
                      />
                    )}
                    {this.props.showButtons && !simplrTaggingActive ? (
                      <TicketButton
                        label="TAKE"
                        buttonId={escalateTakeBtn}
                        fullColored={true}
                        active={!simplrTaggingActive}
                        disabled={simplrTaggingActive}
                        clickAction={async (buttonId) => this.onClickTake(buttonId)}
                        setBtnActivity={!simplrTaggingActive && setBtnActivity}
                      />
                    ) : (
                      <TicketButton
                        label="TAKE"
                        fullColored={true}
                        buttonId={escalateTakeBtn}
                        active={!simplrTaggingActive}
                        disabled={simplrTaggingActive}
                        setBtnActivity={!simplrTaggingActive}
                      />
                    )}
                  </ActionsButtons>
                )}
              </ActionsButtonsWrapper>
            )}
          </EscalatedActionButtonHolder>
        ) : (
          <NoButtonPlaceholder />
        )}

        <SelectedMessage
          isAdmin={isAdmin}
          ticket={ticket}
          showEmailToExperts={showEmailToExperts}
          conversation={selectedConversation}
          isHistoricalTicket={this.props.isHistoricalTicket}
        />
        <MessagesWrapper>
          <MessagesComponent />
        </MessagesWrapper>
      </EscalatedBox>
    );
  }
}

export default EscalatedTicketComponent;
